import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function HealthWellnessForm({ shopType, formState, setFormState }) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* HW_medical */}
      {subtype === 'HW_medical' && (
        <>
          <div className="field">
            <label>Medical Specializations</label>
            <InputText
              value={formState[`medicalSpecializations_${subtype}`] || ''}
              onChange={(e) => setFormState(`medicalSpecializations_${subtype}`, e.target.value)}
              placeholder="e.g. General Medicine, Pediatrics"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`homeVisit_${subtype}`}
                checked={formState[`homeVisit_${subtype}`] || false}
                onChange={(e) => setFormState(`homeVisit_${subtype}`, e.checked)}
              />
              <label htmlFor={`homeVisit_${subtype}`} className="ml-2">Home Visit Available</label>
            </div>
          </div>

          <div className="field">
            <label>Emergency Services Available</label>
            <div className="flex align-items-center">
              {['Yes', 'No'].map(option => (
                <div key={option} className="flex align-items-center mr-4">
                  <RadioButton
                    inputId={`emergency-${option}_${subtype}`}
                    name={`emergencyServices_${subtype}`}
                    value={option}
                    onChange={(e) => setFormState(`emergencyServices_${subtype}`, e.value)}
                    checked={formState[`emergencyServices_${subtype}`] === option}
                  />
                  <label htmlFor={`emergency-${option}_${subtype}`} className="ml-2">{option}</label>
                </div>
              ))}
            </div>
          </div>
        </>
      )
      }

      {/* HW_pharmacy */}
      {
        subtype === 'HW_pharmacy' && (
          <>
            <div className="field">
              <label>Pharmacy Services Offered</label>
              <InputText
                value={formState[`pharmacyServices_${subtype}`] || ''}
                onChange={(e) => setFormState(`pharmacyServices_${subtype}`, e.target.value)}
                placeholder="e.g. Prescriptions, OTC, Vitamins"
              />
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`hasDelivery_${subtype}`}
                  checked={formState[`hasDelivery_${subtype}`] || false}
                  onChange={(e) => setFormState(`hasDelivery_${subtype}`, e.checked)}
                />
                <label htmlFor={`hasDelivery_${subtype}`} className="ml-2">Offers Delivery</label>
              </div>
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`acceptsEPrescriptions_${subtype}`}
                  checked={formState[`acceptsEPrescriptions_${subtype}`] || false}
                  onChange={(e) => setFormState(`acceptsEPrescriptions_${subtype}`, e.checked)}
                />
                <label htmlFor={`acceptsEPrescriptions_${subtype}`} className="ml-2">Accepts e-Prescriptions</label>
              </div>
            </div>
          </>
        )
      }

      {/* HW_fitness */}
      {
        subtype === 'HW_fitness' && (
          <>
            <div className="field">
              <label>Fitness Focus</label>
              <InputText
                value={formState[`fitnessFocus_${subtype}`] || ''}
                onChange={(e) => setFormState(`fitnessFocus_${subtype}`, e.target.value)}
                placeholder="e.g. Weight Training, Yoga, HIIT"
              />
            </div>

            <div className="field">
              <div className="flex align-items-center">

                <Checkbox
                  inputId={`hasTrainer_${subtype}`}
                  checked={formState[`hasTrainer_${subtype}`] || false}
                  onChange={(e) => setFormState(`hasTrainer_${subtype}`, e.checked)}
                />
                <label htmlFor={`hasTrainer_${subtype}`} className="ml-2">Trainer Available</label>
              </div>
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`onlineTraining_${subtype}`}
                  checked={formState[`onlineTraining_${subtype}`] || false}
                  onChange={(e) => setFormState(`onlineTraining_${subtype}`, e.checked)}
                />
                <label htmlFor={`onlineTraining_${subtype}`} className="ml-2">Offers Online Training</label>
              </div>
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`requiresMembership_${subtype}`}
                  checked={formState[`requiresMembership_${subtype}`] || false}
                  onChange={(e) => setFormState(`requiresMembership_${subtype}`, e.checked)}
                />
                <label htmlFor={`requiresMembership_${subtype}`} className="ml-2">Membership Required</label>
              </div>
            </div>
          </>
        )
      }

      {/* HW_spa */}
      {
        subtype === 'HW_spa' && (
          <>
            <div className="field">
              <label>Spa Services Offered</label>
              <InputText
                value={formState[`spaServices_${subtype}`] || ''}
                onChange={(e) => setFormState(`spaServices_${subtype}`, e.target.value)}
                placeholder="e.g. Massage, Facial, Body Scrub"
              />
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`maleTherapist_${subtype}`}
                  checked={formState[`maleTherapist_${subtype}`] || false}
                  onChange={(e) => setFormState(`maleTherapist_${subtype}`, e.checked)}
                />
                <label htmlFor={`maleTherapist_${subtype}`} className="ml-2">Male Therapist Available</label>
              </div>
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`femaleTherapist_${subtype}`}
                  checked={formState[`femaleTherapist_${subtype}`] || false}
                  onChange={(e) => setFormState(`femaleTherapist_${subtype}`, e.checked)}
                />
                <label htmlFor={`femaleTherapist_${subtype}`} className="ml-2">Female Therapist Available</label>
              </div>
            </div>
          </>
        )
      }

      {/* HW_mentalHealth */}
      {
        subtype === 'HW_mentalHealth' && (
          <>
            <div className="field">
              <label>Mental Health Specializations</label>
              <InputText
                value={formState[`mentalSpecializations_${subtype}`] || ''}
                onChange={(e) => setFormState(`mentalSpecializations_${subtype}`, e.target.value)}
                placeholder="e.g. Couples Therapy, Depression, Stress Management"
              />
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`telehealth_${subtype}`}
                  checked={formState[`telehealth_${subtype}`] || false}
                  onChange={(e) => setFormState(`telehealth_${subtype}`, e.checked)}
                />
                <label htmlFor={`telehealth_${subtype}`} className="ml-2">Offers Telehealth</label>
              </div>
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`inPerson_${subtype}`}
                  checked={formState[`inPerson_${subtype}`] || false}
                  onChange={(e) => setFormState(`inPerson_${subtype}`, e.checked)}
                />
                <label htmlFor={`inPerson_${subtype}`} className="ml-2">In-Person Sessions</label>
              </div>
            </div>

            <div className="field">
              <div className="flex align-items-center">
                <Checkbox
                  inputId={`licensed_${subtype}`}
                  checked={formState[`licensed_${subtype}`] || false}
                  onChange={(e) => setFormState(`licensed_${subtype}`, e.checked)}
                />
                <label htmlFor={`licensed_${subtype}`} className="ml-2">Licensed Practitioner</label>
              </div>
            </div>
          </>
        )
      }
    </div >
  );
}
